module.exports = new __parcel__URL__("battlepass_raffle_active_button.8f1dffaa.png").toString();